<!-- item-process-modal.component.html -->
<h2 mat-dialog-title class="bg-primary !text-white">New Item Process</h2>
<ng-container *ngIf="isLoadingCategories || isLoadingProcesses; else formContent">
  <div class="flex items-center justify-center min-h-[200px]">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
</ng-container>
<ng-template #formContent>
  <mat-dialog-content [formGroup]="form">
    <div class="flex just-space-between gap-4">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Category</mat-label>
        <mat-select formControlName="category">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let singleCategory of categories" [value]="singleCategory.key">{{
            singleCategory.value
          }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Always shown fields -->
      <mat-form-field *ngIf="showUniqueId" appearance="fill" class="w-full">
        <mat-label>Unique ID</mat-label>
        <input
          matInput
          formControlName="itemId"
          [matAutocomplete]="auto"
          placeholder="Search Unique ID"
          (focus)="onInputFocus()"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onItemIdSelectionChange($event)"
        >
          <mat-option
            *ngFor="let process of filteredItemProcesses$ | async"
            [value]="process.itemId"
          >
            {{ process.itemId }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <mat-form-field *ngIf="showDescription" appearance="fill" class="w-full">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <!-- Specific Gravity field -->
    <mat-form-field *ngIf="showSpecificGravity" appearance="fill" class="w-full">
      <mat-label>Specific Gravity</mat-label>
      <input matInput type="number" formControlName="specificGravity" />
    </mat-form-field>

    <!-- LBs/1000ft field (for Copper) -->
    <mat-form-field *ngIf="showLbPer1000ft" appearance="fill" class="w-full">
      <mat-label>LBs/1000ft</mat-label>
      <input matInput type="number" formControlName="lbPer1000ft" />
    </mat-form-field>

    <!-- Base Price/Unit field (for Filler, Misc Labor) -->
    <mat-form-field *ngIf="showBasePriceUnit" appearance="fill" class="w-full">
      <mat-label>Base Price/Unit</mat-label>
      <input matInput type="number" formControlName="pricePerUnit" />
    </mat-form-field>

    <!-- Base Price/LB field -->
    <mat-form-field *ngIf="showBasePriceLb || showSurcharge" appearance="fill" class="w-full">
      <mat-label>{{ showSurcharge ? 'Surcharge' : 'Base Price/LB' }}</mat-label>
      <input matInput type="number" formControlName="pricePerLb" />
    </mat-form-field>

    <!-- Constant 1 field -->
    <mat-form-field *ngIf="showConstant1" appearance="fill" class="w-full">
      <mat-label>Constant 1</mat-label>
      <input matInput type="number" formControlName="constant1" />
    </mat-form-field>

    <!-- Constant 2 field -->
    <mat-form-field *ngIf="showConstant2" appearance="fill" class="w-full">
      <mat-label>Constant 2</mat-label>
      <input matInput type="number" formControlName="constant2" />
    </mat-form-field>

    <!-- Read-only Base Price -->
    <mat-form-field *ngIf="showReadOnlyBasePrice" appearance="fill" class="w-full">
      <mat-label>Base Price</mat-label>
      <input matInput [value]="readOnlyBasePriceValue" readonly />
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button [mat-dialog-close]="true" mat-flat-button type="button">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="form.invalid" (click)="onSubmit()">
      Save
    </button>
  </mat-dialog-actions>
</ng-template>
